import ModelStore from "./ModelStore";
import Model from "./ModelStore/Model";
import ModalsStore from "./ModalsStore";
import ViewStore from "./ViewStore";
import BaseStore from "./BaseStore";
import UIStore from "./UIStore";
import TranslationsStore from "./TranslationsStore";
import ModalHandler from "./ModalsStore/ModalHandler";

export default {
  Model,
  ModelStore,
  ModalsStore,
  ModalHandler,
  ViewStore,
  BaseStore,
  UIStore,
  TranslationsStore
};



// WEBPACK FOOTER //
// ./src/Core/Stores/index.js